export class GoToMonthlyTabEvent {}
